import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabelDeleted: string;
    deleted: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for deleted asset location breadcrumb */
            ariaLabelDeleted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetPathnameDeleted.ariaLabelDeleted?c=rpwbl2qsw4ev", defaultMessage: "Deleted asset location" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label indicating the asset has been recently deleted */
            deleted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetPathnameDeleted.deleted?c=3fwnxu20vdvba", defaultMessage: "Recently Deleted" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
